import React from "react";
import styled from "styled-components";
import get from "lodash/get";

import CameraAltIcon from "@mui/icons-material/CameraAlt";

import Button from "../shared/Button";
import EstateItemHeader from "./EstateItemHeader";

const ActionBtnContainer = ({ handleSelect, isSelected, hasValue }) => (
  <div className="d-flex align-items-center unit-actions">
    <Button
      className="unit-action-btn"
      color="primary"
      variant={hasValue && !isSelected ? "contained" : "transparent"}
      onClick={() => handleSelect(false)}
    >
      Ignorer
    </Button>
    <Button
      className="unit-action-btn"
      color="primary"
      variant={isSelected ? "contained" : "transparent"}
      onClick={() => handleSelect(true)}
    >
      Ajouter
    </Button>
  </div>
);

const UnitItem = ({ estate, hasValue, isSelected, handleSelectUnit }) => {
  const {
    id,
    name,
    address,
    number,
    box,
    floor,
    zip,
    city,
    country,
    displayStatusId,
    purpose,
    purposeStatus,
    price,
    currency,
    pictures = [],
    category,
    canHaveChildren,
    parentId,
    room,
  } = estate;

  const isProject = canHaveChildren && !parentId;
  const computedAddress = [address, number, box, floor]
    .filter(Boolean)
    .join(" ");
  const fullAddress = [computedAddress, zip, city].filter(Boolean).join(", ");
  const imageUrl = get(pictures, [0, "urlSmall"], "");

  return (
    <StyleWrapper
      className={`estate__list__item d-flex justify-content-center align-items-center ${
        hasValue ? "has-value" : ""
      }`}
    >
      <div className="estate__list__item-img">
        <img src={imageUrl} alt="" />
        <span className={`purpose purpose-${get(purpose, "id")}`}>
          {get(purpose, "name")}
        </span>
        <span className="pictures">
          <CameraAltIcon htmlColor="var(--white)" />
          {pictures.length}
        </span>
      </div>
      <div className="estate__list__item-info">
        <EstateItemHeader
          isUnitView
          id={id}
          name={name}
          category={get(category, "name")}
          purposeStatus={get(purposeStatus, "name")}
          displayStatusId={displayStatusId}
          fullAddress={fullAddress}
          country={get(country, "name")}
          price={price}
          currency={currency}
          displayPurposeStatus
          isProject={isProject}
          room={room}
          actions={
            <ActionBtnContainer
              handleSelect={handleSelectUnit}
              hasValue={hasValue}
              isSelected={isSelected}
            />
          }
        />
      </div>
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.estate__list__item {
    border-radius: 12px;
    background-color: var(--white);
    padding: 15px;
    margin: 0 15px;
    box-shadow: 0px 0px 10px -6px rgba(130, 130, 130, 1);

    &.has-value {
      background-color: #ebecef;

      &.selected .unit-actions .unit-action-btn:last-child {
        background-color: var(--blue-dark);
        color: var(--white);
      }
    }

    &:first-child {
      margin-top: 10px;
    }

    &:last-child {
      margin-bottom: 10px;
    }

    .estate__list__item-img {
      position: relative;

      img {
        width: 216px;
        height: 140px;
        border-radius: 3px;
      }

      & .purpose {
        position: absolute;
        top: 10px;
        left: 10px;
        border-radius: 3px;
        padding: 2px 10px;

        color: var(--white);
        background-color: var(--red-color);
        text-transform: capitalize;
        font-size: 13px;
        font-weight: 700;

        &.purpose-2 {
          background-color: var(--blue-dark);
        }

        &.purpose-3 {
          // TODO: confirmer la couleur du background pour la vente en viager
        }
      }

      & .pictures {
        position: absolute;
        display: flex;
        align-items: center;
        left: 10px;
        bottom: 10px;
        color: var(--white);
        font-size: 10px;

        & > svg {
          font-size: 12px;
          margin-right: 5px;
        }
      }
    }

    .estate__list__item-info {
      margin-left: 30px;
      margin-right: 15px;
      flex-grow: 1;
    }

    .full-address {
      max-width: 250px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .unit-actions {
      gap: 10px;
    }

    .unit-action-btn {
      font-size: 14px;
      font-weight: 700;
      padding: 5px 25px;
    }

    .location {
      margin: 7px 0;
    }

    .name-container,
    .price-container .price {
      margin-bottom: 8px;
    }

    .price-container {
      justify-content: flex-end !important;
    }
  }
`;

export default UnitItem;
